import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}><path d="M7 7a24 24 0 1034 0A24 24 0 007 7zm26.87 9.9L26.83 24l7.07 7.07-2.83 2.83L24 26.83l-7.07 7.07-2.83-2.83L21.17 24l-7.07-7.07 2.83-2.83L24 21.17l7.07-7.07z" /></svg>);